class MulticolumnModule extends HTMLElement {
  connectedCallback() {
    this._onSectionLoad = (e) => {
      if (e.detail.sectionId === this.dataset.sectionId) {
        customElements.whenDefined(`swiper-container`).then(() => this.initSwiper());
      }
    };

    document.addEventListener(`shopify:section:load`, this._onSectionLoad);
    customElements.whenDefined(`swiper-container`).then(() => this.initSwiper());
  }

  disconnectedCallback() {
    document.removeEventListener(`shopify:section:load`, this._onSectionLoad);
  }

  initSwiper() {
    const el = this.querySelector(`swiper-container`);
    if (!el || el.swiper) return;

    const desktopCarousel      = this.dataset.desktopCarousel === `true`;
    const mobileCarousel       = this.dataset.mobileCarousel === `true`;
    const desktopColumns       = parseInt(this.dataset.desktopColumns, 10);
    const desktopSlidesPerView = parseFloat(this.dataset.desktopSlidesPerView);
    const columnGap            = parseInt(this.dataset.gap, 10);
    const slideCount           = parseInt(this.dataset.slideCount, 10);
    const desktopAllFit = slideCount <= desktopColumns;
    const mobileAllFit  = slideCount <= 1;

    /*
     * Each pagination bullet: 3.8rem wide + 0.5rem margin each side = 4.8rem total.
     * Half pagination width = slideCount × 2.4rem.
     */
    const arrowOffset = `${slideCount * 2.4 + 0.5}rem`;

    let css = ``;

    /* Allow slides to bleed past the container boundary */
    if (desktopCarousel || mobileCarousel) {
      css += `.swiper { overflow: visible; }`;
    }

    /* ── Grid override when desktop carousel is off ─────── */
    if (!desktopCarousel) {
      css += `
        @media (min-width: 990px) {
          .swiper-wrapper {
            display: grid !important;
            grid-template-columns: repeat(${desktopColumns}, 1fr);
            gap: ${columnGap}px;
            transform: none !important;
            width: 100% !important;
          }
          .swiper-slide { width: 100% !important; height: auto !important; margin-right: 0 !important; }
        }
      `;
    }

    /* ── Stack override when mobile carousel is off ─────── */
    if (!mobileCarousel) {
      css += `
        @media (max-width: 989px) {
          .swiper-wrapper {
            display: flex !important;
            flex-direction: column !important;
            gap: ${columnGap}px;
            transform: none !important;
            width: 100% !important;
          }
          .swiper-slide { width: 100% !important; height: auto !important; margin-right: 0 !important; }
        }
      `;
    }

    /* ── Controls inside shadow DOM ─────────────────────── */
    if (desktopCarousel || mobileCarousel) {
      css += `
        .swiper-pagination-bullet { width: 3.8rem; height: .4rem; background: #D9D9D9; border-radius: 0; opacity: 1; margin: 0 .5rem; }
        .swiper-pagination-bullet-active { background: #000; }
        .swiper-button-prev, .swiper-button-next { display: none; }
      `;
    }

    if (mobileCarousel) {
      if (mobileAllFit) {
        css += `
          @media (max-width: 989px) {
            .swiper-pagination, .swiper-button-prev, .swiper-button-next { display: none !important; }
          }
        `;
      } else {
        css += `
          @media (max-width: 989px) {
            .swiper { padding: 2px; padding-bottom: 7.3rem; }
            .swiper-pagination { bottom: 2.2rem !important; }
          }
        `;
      }
    }

    if (desktopCarousel) {
      if (desktopAllFit) {
        css += `
          @media (min-width: 990px) {
            .swiper-pagination, .swiper-button-prev, .swiper-button-next { display: none !important; }
          }
        `;
      } else {
        css += `
          @media (min-width: 990px) {
            .swiper { padding: 2px; padding-bottom: 7.3rem; }
            .swiper-pagination { bottom: 1.2rem !important; height: 2.4rem; display: flex; align-items: center; justify-content: center; }
            .swiper-button-prev, .swiper-button-next { display: flex; align-items: center; justify-content: center; top: auto; bottom: 1.2rem; width: 2.4rem; height: 2.4rem; margin-top: 0; --swiper-navigation-color: #000; --swiper-navigation-size: 1.2rem; z-index: 11; }
            .swiper-button-prev { left: auto; right: calc(50% + ${arrowOffset}); }
            .swiper-button-next { right: auto; left: calc(50% + ${arrowOffset}); }
          }
        `;
      }
    }

    Object.assign(el, {
      enabled: mobileCarousel,
      breakpoints: {
        990: {
          enabled: desktopCarousel,
          slidesPerView: desktopSlidesPerView,
          spaceBetween: columnGap,
        },
      },
      injectStyles: [css],
    });

    el.initialize();
  }
}

customElements.define(`multicolumn-module`, MulticolumnModule);
